import { useState } from 'react';
import { format } from 'date-fns';
import { Calendar as CalendarIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export const DatePicker = ({ selected, onSelect }) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="rounded-none border-[#E5E5E0] hover:bg-[#EFEFEA]"
          data-testid="date-picker-button"
        >
          <CalendarIcon size={18} className="mr-2" />
          Select Date
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-none border-[#E5E5E0]" align="end">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(date) => {
            onSelect(date);
            setOpen(false);
          }}
          initialFocus
          data-testid="date-picker-calendar"
        />
      </PopoverContent>
    </Popover>
  );
};

export default DatePicker;
